import React, { useEffect, useState } from 'react';
import { Box, Button, Typography, FormControl } from '../../imports/muiImport';

import BasicBtn from '../../components/button/BasicBtn';
import OtpInput from 'react18-input-otp';
import './MobileOTPStyle.css';
const OTPComponent = (props) => {
  const {
    email,
    onVerifyOtp,
    onResendOtp,
    isResendAvailable = false,
    purpose = 'Verify OTP',
    isResetOtp,
  } = props;
  const [otp, setOtp] = useState('');

  const handleChange = (value) => setOtp(value);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (otp?.length === 6) {
      onVerifyOtp(email, otp);
    }
  };

  const resetOTP = () => {
    setOtp('');
  };

  useEffect(() => {
    resetOTP();
  }, [isResetOtp]);

  return (
    <>
      <Box
        component={'div'}
        sx={{
          mt: 3,
        }}
      >
        <Box textAlign="center">
          <Typography variant="h5" fontWeight={400}>
            {purpose}
          </Typography>

          <Typography variant="subtitle1" sx={{ mb: 2 }}>
            Code sent to: <strong>{email}</strong>
          </Typography>

          <FormControl component="form" onSubmit={handleSubmit}>
            <OtpInput
              value={otp}
              onChange={handleChange}
              numInputs={6}
              className="digitInput"
              shouldAutoFocus
              isInputNum
              containerStyle={{
                justifyContent: 'center',
                gap: '4px',
              }}
            />

            <Box mt={2}>
              <BasicBtn
                type="submit"
                name="Verify OTP"
                color="secondary"
                smColor="primary"
                disabled={otp?.length !== 6}
                sx={{ mt: 3 }}
              />
            </Box>
          </FormControl>

          <Box mt={2}>
            <Typography variant="body2">
              Didn’t get the code?
              <Button
                variant="text"
                disabled={!isResendAvailable}
                onClick={() => onResendOtp()}
                sx={{ textTransform: 'capitalize', fontWeight: 500 }}
              >
                Resend
              </Button>
            </Typography>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default OTPComponent;
